
import React, { useState, useEffect } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

// Assets
import "~/assets/sass/pages/mypage/account/account.scss";
import useRequest from "~/common/hooks/useRequest";

// Pages
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import { logout } from "~/store/auth/actions";
import CardFront from "./components/CardFront";
import CardBack from "./components/CardBack";
import Edit from "./components/Edit";
import { Helmet } from "react-helmet-async";
import { getTitle } from "~/utils/getTitle";
import { useTranslation } from "react-i18next";


const Profile = () => {

    const { t } = useTranslation();

    const [, dispatch] = useGlobalStore();
    const [profileEditModal, setProfileEditModal] = useState(false);
    const userDetailRequest = useRequest("get", "vc/user/info");
    const userModifyRequest = useRequest("post", "/vc/user/info/edit");
    const [userInfo, setUserInfo] = useState([]);
    const [userProfile, setUserProfile] = useState({});
    const [userTerm, setUserTerm] = useState([]);

    const doReload = () => {
        userDetailRequest.call();
    };

    useEffect(() => {
        userDetailRequest.singleCall();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        switch (userDetailRequest.state) {
            case API_STATE.done:
                const putUserDate = userDetailRequest.response?.data?.user;
                setUserTerm(userDetailRequest.response?.data?.userTerm);
                setUserInfo(putUserDate);
                setUserProfile(putUserDate.UserProfile);
                break;
            case API_STATE.error:
                switch (userDetailRequest.error.statusCode) {
                    case 404:
                        alert(t("common.commonWord.alert.user"));
                        dispatch(logout());
                        break;
                    case 500:
                        alert(t("common.commonWord.alert.wait1"));
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [userDetailRequest.state, userDetailRequest.response, userDetailRequest.error]);

    useEffect(() => {
        switch (userModifyRequest.state) {
            case API_STATE.done:
                setProfileEditModal(false);
                doReload();
                userModifyRequest.setState(API_STATE.ready);
                break;
            case API_STATE.error:
                console.error(userModifyRequest.error);
                alert(t("pages.myPage.AccountPage.editError"));
                break;
            default:
                break;
        }
    }, [userModifyRequest.state, userModifyRequest.error]);
    return(
        <>
            <Helmet>
                <title>{getTitle(`내 프로필`)}</title>
            </Helmet>
            <NavbarAndSidebarLayout menu={["management", "profile"]} type={"main"}>
                <PageHeader />
                <div className="c__card-wrap">
                    <CardFront userInfo={userInfo} userProfile={userProfile} />
                    <CardBack userInfo={userInfo} userProfile={userProfile} setProfileEditModal={setProfileEditModal} />
                </div>
            </NavbarAndSidebarLayout>
            <ModalTemplate
                modalState={profileEditModal}
                setModalToggle={setProfileEditModal}
                title={t("pages.myPage.AccountPage.modalTitle")}
                width={740}
                height={550}
                className="profile-edit-modal"
            >
                <Edit
                    userProfile={userProfile}
                    userInfo={userInfo}
                    userTerm={userTerm}
                    userModifyRequest={userModifyRequest}
                    setModalToggle={setProfileEditModal}
                />
            </ModalTemplate>
        </>
    )
}

export default Profile
